import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustomerGroupItem, CustomerService, CustType, FindCustomersGet } from '@app/services/customer.service';
import { FindCustomersGridComponent } from './find-customers-grid/find-customers-grid.component';
import { FindCustomersListComponent } from './find-customers-list/find-customers-list.component';

@Component({
    selector: 'tt-find-customers',
    templateUrl: './find-customers.component.html',
    styleUrls: ['./find-customers.component.css'],
    standalone: false,
})
export class FindCustomersComponent implements OnInit {
    public page?: FindCustomersGet;

    public customerGroups: CustomerGroupItem[] = [];

    public grid?: GridOptions;

    @ViewChild(FindCustomersGridComponent)
    public gridComponent?: FindCustomersGridComponent;

    @ViewChild(FindCustomersListComponent)
    public listComponent?: FindCustomersListComponent;

    constructor(
        private customer: CustomerService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async readGrid(allowEmptySearch = false) {
        await Promise.all([this.gridComponent?.readGrid(allowEmptySearch), this.listComponent?.loadCustomers()]);
    }

    public async onShowLastVisitedCustomersChanged(value: string) {
        if (!this.page || (value !== '1' && value !== '0')) return;

        this.page.show_last_visited_customers = value;
        await this.readGrid();
    }

    public async onLastCustomersSelectionChanged(value: string) {
        if (value !== 'LAST' && value !== 'SEARCH') return;

        await this.onShowLastVisitedCustomersChanged(value === 'LAST' ? '1' : '0');
    }

    public onFindCustomersSelectionChanged(value: string) {
        if (!this.page || !this.isCustType(value)) return;

        this.page.findcustomers_selection = value;
        void this.readGrid();
    }

    private async loadPage() {
        this.page = await this.customer.getFindCustomers();
        this.page.show_last_visited_customers = String(this.page.show_last_visited_customers) === '1' ? '1' : '0';
        this.page.cust_name ??= '';

        if (!this.page.custgrp_id) {
            this.page.custgrp_id = 'ALL';
        }
    }

    private async loadCustomerGroups() {
        this.customerGroups = await this.customer.getCustomerGroups({ add_all: '1' });
    }

    private async init() {
        await Promise.all([this.loadPage(), this.loadCustomerGroups()]);
    }

    private isCustType(value: string): value is CustType {
        return value === 'C' || value === 'A' || value === 'S' || value === 'O' || value === 'D';
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.navigator.setHeading?.('findcustomersuppliers', true);
        }

        void this.init();
    }
}
